import {
    Box,
    Button,
    IconButton,
    ListItem,
    ListItemButton,
    ListItemText,
    Popover,
    Tab,
    Tabs,
    Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SortIcon from "../../assets/icons/Sort.svg";
import SVG from "react-inlinesvg";
import { useLocation, useNavigate } from "react-router-dom";
import { links } from "../../constants/links";
import { useInfiniteQuery } from "react-query";
import { getMultiCoupons } from "../../services/ads/ads.service";
import { Loading } from "../../components";
import { commonDateFormat } from "../../utils/date-format";
import moment from "moment";
import { ListStatus } from "../use-reward";
import { getValueByLanguage, isExpiredToday } from "../../utils/utils";
import { useTranslation } from "react-i18next";
import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import { LIST_LANGUAGE_ENUM } from "../../constants";
import { LOCAL_STORAGE_KEY_CURRENT_LANGUAGE } from "../../constants";
import { getListRewardPageViewMoreButtonStyles, getListRewardPageUseNowButtonStyles } from "../../utils/buttonStyle";
import { sortFields, sortUseList, sortDirection, MAX_PER_PAGE, TABS } from "./constants";
import {
    ListRewardsWrapper,
    VoucherWrapper,
    ViewMoreBtn,
    ExpiredDate,
    ListWrapper
  } from "./MultiCoupons.styles";
import { List } from "lodash";



const defaultCountry = process.env.REACT_APP_DEFAULT_COUNTRY;

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
};


const a11yProps = (index: number) => {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
};


const MultiCoupons = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const { t } = useTranslation();
    const tab = TABS.USE;
    const [value, setValue] = useState(+tab);
    const [offsetUse, setOffsetUse] = useState(0);
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const [sortUseValue, setSortUseValue] = useState(sortFields.CREATE_DATE);
    const [directionUse, setDirectionUse] = useState(sortDirection.ASC);
    const is_reload = searchParams.get("is_reload") ?? false;
    const engage_session_id = searchParams.get("engage-session") || "";


    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const {
        data: rawUseData,
        isLoading: isLoadingUse,
        fetchNextPage: fetchNextUsePage,
        isFetching: isFetchingUse
    } = useInfiniteQuery({
        queryKey: ["use", directionUse, sortUseValue, engage_session_id],
        queryFn: ({ pageParam = 0 }) => {
            return getMultiCoupons({
                offset: pageParam,
                orderBy: directionUse + sortUseValue,
                defaultCountry: defaultCountry,
                language_code: localStorage.getItem(LOCAL_STORAGE_KEY_CURRENT_LANGUAGE) || LIST_LANGUAGE_ENUM.EN,
                engage_session_id: engage_session_id
            });
        },
        staleTime: Infinity,
    });

    useEffect(() => {
        if (is_reload) {
            window.location.replace(links.EARN_PAGE + "?tab=1");
        }
    }, [is_reload]);

    useEffect(() => {
        const newOffset = rawUseData && rawUseData?.pages ? (rawUseData?.pages.length - 1) * 10 : 0;
        setOffsetUse(newOffset);
    }, [rawUseData]);

    const navigate = useNavigate();

    const used = (data: any) => data?.status === ListStatus.COMPLETED;

    const handleUse = (item: any, used?: boolean) => {
        if (engage_session_id) {
            navigate(`${links.USE_REWARD_V2}/?engage-session=${engage_session_id}&coupon-session=${item.cp_session_id}`, {
                state: { used: used, type: item.status, customer_subcampaign_id: item.customer_subcampaign_id, fromPath: "EARN_REWARD" }
            });
        } else {
            navigate(links.USE_REWARD.replace(":id", item.id), {
                state: { used: used, type: item.status, customer_subcampaign_id: item.customer_subcampaign_id, fromPath: "EARN_REWARD" }
            });
        }
    };

    const handleLoadMoreUse = async () => {
        await fetchNextUsePage({ pageParam: offsetUse + 10 });
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleChangeSort = (key: string) => {
        {
            if (key === sortUseValue) {
                if (directionUse === sortDirection.DESC) {
                    setDirectionUse(sortDirection.ASC);
                } else {
                    setDirectionUse(sortDirection.DESC);
                }
            } else {
                setSortUseValue(key);
                setDirectionUse(sortDirection.ASC);
            }
        }
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    const totalUseItems = rawUseData?.pages[0].total;
    const totalUsedItems = rawUseData?.pages[0].total_used_coupon;
    const totalExpiredItems = rawUseData?.pages[0].total_expired_coupon;
    const hasMoreUse = (
        rawUseData?.pages && rawUseData?.pages.length < Math.ceil((totalUseItems + totalUsedItems + totalExpiredItems) / MAX_PER_PAGE));
    const sortList = sortUseList;

    // components
    const viewMoreBtnWrapper = (
        <ViewMoreBtn
            onClick={handleLoadMoreUse}
            fullWidth
            variant="contained"
            disabled={isFetchingUse}
            style={getListRewardPageViewMoreButtonStyles}
        >
            {t("viewMore")} - 10 {t("items")}
        </ViewMoreBtn>
    );

    const renderNowButton = (item: any) => {
        return (
            <Button
                sx={{ fontWeight: 400, fontSize: 12 }}
                variant="contained"
                onClick={() => handleUse(item)}
                disabled={isExpiredToday(item.expired_at)}
                style={ getListRewardPageUseNowButtonStyles }
            >
                {t("useNow")}
            </Button>
        );
    };

    const RewardLogo = (item: any) => (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            className="ticket firstPart"
        >
            <img src={item.reward_logo_with_text} alt="rewards" />
        </Box>
    );

    const sortComponent = (
        <>
        <IconButton onClick={handleClick}><SVG src={SortIcon} /></IconButton>
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
            }}
        >
            <ListWrapper
                sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
                aria-label="contacts"
            >
                {
                    sortList.map((sort) => (
                        <ListItem key={sort.key} disablePadding>
                            <ListItemButton onClick={() => handleChangeSort(sort.key)}>
                                <ListItemText
                                    className={(sortUseValue) === sort.key ? "active" : ""}
                                    primary={t(sort.label)}
                                />
                                {(sortUseValue) === sort.key &&
                                    <IconButton>
                                        {
                                            ((directionUse) === sortDirection.DESC) ?
                                                <ArrowDownwardRoundedIcon color="error" /> :
                                                <ArrowUpwardRoundedIcon color="success" />
                                        }
                                    </IconButton>
                                }
                            </ListItemButton>
                        </ListItem>
                    ))
                }
            </ListWrapper>
        </Popover>
        </>
    );


    return (
        <ListRewardsWrapper>
            {(isLoadingUse) && <Loading />}
            <Box sx={{ width: "100%" }}>
                <Box display="flex" alignItems="center" justifyContent="space-between" pr={2.5}>
                    <Tabs
                        value={0}
                        // onChange={handleChange}
                        aria-label="basic tabs example"
                    >
                        <Tab
                            icon={<span className="dot">{totalUseItems}</span>}
                            label={t("multicoupon")}
                            {...a11yProps(TABS.USE)}
                            iconPosition="end"
                        />
                    </Tabs>
                    <Box>
                        {/* to sort items */ }
                        {sortComponent}
                    </Box>
                </Box>
                <TabPanel value={value} index={1}>
                    {
                        rawUseData?.pages?.map((page, index) => (
                            <React.Fragment key={"page_" + index}>
                                {
                                    page.data.map((item: any, i: number) => (
                                        <VoucherWrapper
                                            key={"use-item-" + i + "-" + item.id}
                                            mb={2.5}
                                            className=" testTicket"
                                            onClick={
                                                () => {
                                                    !item.is_3rdparty_coupon_use ?
                                                        (used(item) || isExpiredToday(item.expired_at)) ?
                                                            handleUse(item, true)
                                                            : handleUse(item)
                                                        : null;
                                                }
                                            }
                                        >
                                            {RewardLogo(item)}
                                            {/* divieder between firstPart and secondPart */}
                                            <Box className="ticket-divider">
                                                <div className="divider-border" />
                                                <div className="notch"></div>
                                                <div className="notch bottom"></div>
                                            </Box>
                                            <Box
                                                display="flex"
                                                flexDirection="column"
                                                justifyContent="space-between"
                                                className="ticket secondPart"
                                            >
                                                <Box>
                                                    <Typography
                                                        sx={{ fontSize: 12, fontWeight: 600 }}
                                                    >
                                                        {getValueByLanguage(item, "reward_summary")}
                                                    </Typography>
                                                    <Typography
                                                        sx={{ fontSize: 12 }}
                                                        className={"subCampaignTitle"}
                                                    >
                                                        {getValueByLanguage(item, "reward_use_criteria")}
                                                    </Typography>
                                                </Box>
                                                <Box display="flex" justifyContent="space-between">
                                                    <Box>{
                                                        !item?.used_at && (
                                                            <>
                                                                <Typography
                                                                    sx={{ fontSize: 12, fontWeight: 600, color: "#8D8D8D" }}
                                                                >
                                                                    {t("expiredDate")}
                                                                </Typography>
                                                                <ExpiredDate
                                                                    color={isExpiredToday(item.expired_at) ? "error" : ""}
                                                                >
                                                                    {commonDateFormat(moment(item.expired_at))}
                                                                </ExpiredDate>
                                                            </>
                                                        )
                                                    }
                                                    </Box>
                                                    {
                                                        item?.used_at ?
                                                            <ExpiredDate color="error">{`${t("used")}
                                ${commonDateFormat(moment(item.used_at))}`}</ExpiredDate>
                                                            : (renderNowButton(item))
                                                    }
                                                </Box>
                                            </Box>
                                        </VoucherWrapper>
                                    ))
                                }
                            </React.Fragment>
                        ))
                    }
                    {hasMoreUse && viewMoreBtnWrapper}
                </TabPanel>
            </Box>
        </ListRewardsWrapper>
    );
};

export default MultiCoupons;
